<div id="new_message">
  <div class="editpanel">
    <ng-container *ngIf="!hub || !hub.hubid; else onehub">
      <mat-form-field id="hubids">
      <textarea #hubids placeholder="A comma, space, or new-line -separated list of IDs of the Hubs to send to"
                rows="4" cols="40" matInput [(ngModel)]="message.hubid"></textarea>
      </mat-form-field>
    </ng-container>
    <ng-template #onehub><span class="hubid">{{hub.hubid}}</span></ng-template>

    <mat-form-field id="from"><input #from placeholder="From" matInput [(ngModel)]="message.from" maxlength="18"></mat-form-field>

    <mat-form-field id="subject"><input #subject placeholder="Subject" matInput [(ngModel)]="message.subject" maxlength="18"></mat-form-field>

    <mat-form-field id="body">
      <textarea #body placeholder="The body of the message to send to the Hub(s)" rows="4" maxlength="160"
                matInput [(ngModel)]="message.body" cols="30"></textarea>
    </mat-form-field>

    <mat-form-field id="message_type">
      <mat-select #message_type placeholder="The type of message" [(ngModel)]="message.mail_type">
        <mat-option [value]="0">Information</mat-option>
        <mat-option [value]="1">Question</mat-option>
        <mat-option [value]="2">Reorder</mat-option>
      </mat-select>
    </mat-form-field>

    <ng-container *ngIf="message.mail_type > 0">
      <mat-form-field id="positive">
        <input #affirmative placeholder="Affirmative" matInput [(ngModel)]="message.positive" maxlength="8">
      </mat-form-field>
      <mat-form-field id="negative">
        <input #negative placeholder="Negative" matInput [(ngModel)]="message.negative" maxlength="8">
      </mat-form-field>
    </ng-container>

    <span class="panel">
      <button mat-raised-button (click)="cancel()">Cancel</button>
      <button mat-raised-button color="primary" (click)="send()" [disabled]="!isValid()">Send</button>
    </span>
  </div>
  <ng-container *ngIf="messageSendFailed">
    <div class="mat-error">{{messageFailMessage}}</div>
  </ng-container>
</div>
